// extracted by mini-css-extract-plugin
module.exports = {"translateButton":"TranslateButton_translateButton__1tOKa","isLoading":"TranslateButton_isLoading__1Q6FT"};